import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CoreModule } from 'app/core/core.module';
import { FundraiserListService } from 'app/manage-p2p/services/fundraiser-list/fundraiser-list.service';
import * as _ from 'lodash'
import { P2pDonorDetailsCardComponent } from '../p2p-donor-details-card/p2p-donor-details-card.component';

@Component({
  standalone:true,
  selector: 'app-p2p-donor-details',
  templateUrl: './p2p-donor-details.component.html',
  styleUrl: './p2p-donor-details.component.scss',
  imports:[P2pDonorDetailsCardComponent,CommonModule,CoreModule]
})
export class P2pDonorDetailsComponent implements OnInit{

  @Input() donation = null;
  @Output() selectedFundraiser = new EventEmitter<any>();

  public campaign = null;
  public uniqFundraisers = [];

  public readMoreOptions = null;
  public col12 = {};

  public name: string = '';
  public email: string = '';
  public phone: any = null;
  public donorAddressText: string = '';

  public showInfo = false;
  public showStreetAddress = false;
  public showPhone = false;
  public showAdditionalInfo = false;
  public showAdditionalInfoSelect = false;

  constructor(
    public fundraiserListService: FundraiserListService
  ) {}

  ngOnInit() {
    this.readMoreOptions = {
      webkitLineClamp: [2,2,3,3,3],
    };

    const { additionalInfoSelected, campaignAdditionalInfo } = this.donation;
    const payer = this.donation.payer || this.donation;
    const { id , name, email, phone, address } = payer;

    this.name = name;
    this.email = email;
    this.phone = phone;

    const addressText = window['utils'].getStreetAddressText(address);
    this.donorAddressText = addressText;

    const fundraisersByUser = this.fundraiserListService.getFundraiserListByUserId(id);
    const fundraisersByDonor = this.fundraiserListService.getFundraiserListByDonorId(id);

    const allFundraisers = fundraisersByUser.concat(fundraisersByDonor);
    this.uniqFundraisers = _.uniqBy(allFundraisers, 'id');

    this.campaign = this.fundraiserListService.campaign();
    const {phoneNumRequired, streetAddressRequired, additionalInfoRequired, additionalInfoSelectRequired } = this.campaign.campaignTypeData;

    this.showPhone = phoneNumRequired && this.phone;
    this.showStreetAddress = streetAddressRequired && this.donorAddressText != '';
    this.showAdditionalInfo = additionalInfoRequired && campaignAdditionalInfo != '';
    this.showAdditionalInfoSelect = additionalInfoSelectRequired && additionalInfoSelected;

    this.col12 = {
      'col-12': !this.showAdditionalInfo && !this.showAdditionalInfoSelect
    }  

    if(this.showPhone || this.showStreetAddress || this.showAdditionalInfo || this.showAdditionalInfoSelect) {
      this.showInfo = true;
    } else {
      this.showInfo = false;
    }
  }

  fundraiserSelected(fundraiser) {
    this.selectedFundraiser.emit(fundraiser);
  }
}
